import * as $ from "jquery";
import ViewportTracker from '../../lib/ViewportTracker';

import { Analytics } from '@plaudit/analytics';
const analytics = Analytics.getInstance();

/**
 * Grabs the account access forms and makes them available under the "Log In" button.
 *
 * Sadly, a tiny bit of jquery is needed here :/
 */
export default class AccountAccess {
	public containerSelector: string = '#accountLogin';
	public container: Element = document.querySelector(this.containerSelector);
	public button: Element = document.querySelector(this.containerSelector + ' > a.btn');
	public formOuter: Element = document.getElementById('accountAccessWrap');
	public select: HTMLSelectElement;
	public activeClass: string = 'accountAccessOpen';
	/*GA*/public firstRun: boolean = true;

	private handleButtonClick = (event: Event) => {
		event.preventDefault();

		if (this.container.classList.contains(this.activeClass)) {
			this.toggleClose();
		} else {
			this.toggleOpen(event);
		}
	}
	private handleGlobalEvents = (event: any) => {
		switch (event.type) {
			case 'keyup':
				if (event.key === 'Escape') {
					this.toggleClose();
				}
				break;
			case 'click':
			case 'touchstart':
				if ($(event.target).closest(this.containerSelector) === null) {
					this.toggleClose();
				}
				break;
		}
	}
	private selectionSync = () => {
		const selectedId = this.select.options[this.select.selectedIndex].value;
		const sections = this.container.querySelectorAll('section');
		for (let i = 0, l = sections.length; i < l; i++) {
			sections[i].classList.remove('active');
		}
		document.getElementById(selectedId).classList.add('active');

		if (!this.firstRun){
			/*GA*/analytics.trackEvent('Login Dialog', 'Change Selection', selectedId);
		}
	}
	private toggleClose = () => {
		this.container.classList.remove(this.activeClass);
		document.documentElement.classList.remove('lockScroll');

		window.removeEventListener('click', this.handleGlobalEvents);
		window.removeEventListener('touchstart', this.handleGlobalEvents);
		document.removeEventListener('keyup', this.handleGlobalEvents);

		/*GA*/analytics.trackEvent('Login Dialog', 'Close');
	}
	private toggleOpen(event: Event) {
		this.container.classList.add(this.activeClass);
		this.select.focus();

		if (ViewportTracker.below('mobileMenu', true)) {
			document.documentElement.classList.add('lockScroll');
		}

		window.addEventListener('click', this.handleGlobalEvents);
		window.addEventListener('touchstart', this.handleGlobalEvents);
		document.addEventListener('keyup', this.handleGlobalEvents);

		/*GA*/analytics.trackEvent('Login Dialog', 'Open');
	}
	constructor() {
		$(this.formOuter).load(this.button.getAttribute('href') + ' #accountAccess', () => {
			this.select = document.getElementById('loginSwitcher') as HTMLSelectElement;

			this.select.addEventListener('change', this.selectionSync);
			this.button.addEventListener('click', this.handleButtonClick);

			this.selectionSync();
			/*GA*/this.firstRun = false;
		});
	}
}